
import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import Table from '@/store/modules/Table'
import Pictures from './modules/Pictures'

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
	modules: {
		Table,
		Pictures
	}
}
